module.exports = __webpack_public_path__ + "img/mtn_money.79a59e20.png";